module.exports = "/_next/static/images/fulfillmentServices-777f387f3cb2b1dc1b162ee1019ebf06.webp";